module.exports = __webpack_public_path__ + "static/media/aiub.db825b14.png";